import React from 'react' 
import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import useGetBusiness from '../../../hooks/useGetBusiness'

function Business({id}) {
    const b = useGetBusiness(id)
console.log(b)
  return (
    <Grid item xs={6} md={4}>
    <Card sx={{p:3}}>
    <Box>
        <Stack>
    <Typography>

    {b?.name}
    </Typography>
        </Stack>
    </Box>
    </Card>
</Grid>
  )
}

export default Business